var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col"},[(_vm.loading == false)?_c('TableTemplate',{attrs:{"candelete":false,"canview":"/orders/","columns":_vm.columns,"items":_vm.orders}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }